import * as Joi from "joi";
import {
	Column,
	Entity,
	JoinColumn,
	ManyToOne,
	OneToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { GenPartial } from 'typeormgen';
import CmWrapBox from '../cm-wrap-boxes/cm-wrap-box.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';
import WrapBoxInventory from '../wrap-box-inventory/wrap-box-inventory.entity';

@Entity('cm_wrap_box_episodic_items')
export default class CmWrapBoxEpisodicItem extends WrapBoxInventory {
	static readonly tableName = 'cm_wrap_box_episodic_items';
	static readonly cmWrapBoxForeignKeyName = 'cm_wrap_box_id';
	static readonly episodicItemForeignKeyName = 'episodic_item_id';

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	cm_wrap_box_id: number;

	@Column('int')
	episodic_item_id: number;

	@Column('int')
	quantity: number;

	@Column('int')
	change_id: number;

	@OneToOne(
		(type) => EpisodicItem,
		(episodicItem) => episodicItem.cmWrapBoxEpisodicItem
	)
	@JoinColumn({
		name: CmWrapBoxEpisodicItem.episodicItemForeignKeyName,
	})
	episodicItem: EpisodicItem;

	@ManyToOne(
		(type) => CmWrapBox,
		(cmWrapBox) => cmWrapBox.cmWrapBoxEpisodicItems
	)
	@JoinColumn({
		name: CmWrapBoxEpisodicItem.cmWrapBoxForeignKeyName,
	})
	cmWrapBox: CmWrapBox;

	static rules() {
		return {
			...super.rules(),
			cm_wrap_box_id: Joi.number().integer(),
			episodic_item_id: Joi.number().integer(),
			quantity: Joi.number().integer().allow(null),
			change_id: Joi.number().integer().allow(null),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			cm_wrap_box_id: this.cm_wrap_box_id,
			episodic_item_id: this.episodic_item_id,
			quantity: this.quantity,
			change_id: this.change_id,
		};
	}

	assign(props?: GenPartial<CmWrapBoxEpisodicItem>) {
		super.assign(props);
	}

	constructor(props?: GenPartial<CmWrapBoxEpisodicItem>) {
		super(props);
	}
}
